import { DEFAULT_LOCATIONS, DEFAULT_RADIUS, DROPDOWN } from 'utils/constants';
import { selectMapKey, EnvTokenMap } from 'utils/selectToken';
import { DefaultLocalClientConfig } from './localConfig.types';

const azureMapsKeys: EnvTokenMap = {
  dev: 'KzRiwn3ytsCi9Hp_x5utRumI8eCEnsWPDK9ljSWvJcw',
  staging: 'qHn_TowRlwaSwIVj91ehzljIcE7O_sLFeGvBCVSYa2c',
  prod: '74e5OQx_c0l_8xNlwwKD4BCdl7-6KOkARE42uhzfQAY',
};

const azureMapsKey = selectMapKey(azureMapsKeys);

const defaultConfig: DefaultLocalClientConfig = {
  // api & auth
  API_URL: 'https://fusion.prod.emboldhealth.com/api/pg',
  AZURE_MAPS_KEY: azureMapsKey,

  SHOW_REGION_SELECTOR: true,
  SHOW_BENEFIT_DIFF: false,
  HIGH_QUALITY_INTRO_MODAL: false,

  // other
  DEFAULT_LOCATION: { ...DEFAULT_LOCATIONS.Dallas },
  DEFAULT_SEARCH_RADIUS: DEFAULT_RADIUS,
  NETWORKS: {},

  // content
  FORM_VARIANT: DROPDOWN,
  NO_WELCOME_LINK: true,
};

export default defaultConfig;
